export default __webpack_public_path__ + "images/0x07865c6e87b9f70255377e024ace6630c1eaa37f.png";